import React from "react";
import "./ResetTasksFlow.css";

function ResetTaskProgressBar({ steps, currentStep = 0 }) {
  if (!steps || steps.length === 0) {
    return null;
  }

  return (
    <div className="reset-task-progress" aria-label="Reset task progress">
      {steps.map((step, index) => {
        const stateClass =
          index < currentStep ? "complete" : index === currentStep ? "active" : "";

        return (
          <div
            className={`reset-task-progress-step ${stateClass}`}
            key={step}
          >
            <span className="reset-task-progress-marker">{index + 1}</span>
            <span className="reset-task-progress-label">{step}</span>
          </div>
        );
      })}
    </div>
  );
}

export default ResetTaskProgressBar;
